module.exports = __webpack_public_path__ + "img/ico_caiwuguanli_yuanneishengdanchaxun.4e7e4121.png";